import {CommonOrderModel} from '../../revenue/revenue-shared/CommonOrder';
import {Directive, EventEmitter, HostBinding, HostListener, Input, Output} from '@angular/core';

export type SortColumn = keyof CommonOrderModel | '';
export type SortDirection = 'asc' | 'desc';
const rotate: {[key: string]: SortDirection} = { asc: 'desc', desc: 'asc' };

export interface SortEvent {
    column: SortColumn;
    direction: SortDirection;
}

@Directive({
    selector: 'th[appSortable]',
    standalone: false

})
export class SortableHeaderDirective {
    @Input() appSortable: SortColumn = '';
    @Input() direction: SortDirection = 'desc';
    @Output() sort = new EventEmitter<SortEvent>();

    @HostBinding('class.asc')
    get isAsc() {
        return this.direction === 'asc';
    }

    @HostBinding('class.desc')
    get isDesc() {
        return this.direction === 'desc';
    }

    @HostListener('click')
    rotate() {
        this.direction = rotate[this.direction];
        this.sort.emit({ column: this.appSortable, direction: this.direction });
    }
}
